import { render, staticRenderFns } from "./NeedsApprovalDetail.vue?vue&type=template&id=61fa470a&scoped=true"
import script from "./NeedsApprovalDetail.vue?vue&type=script&lang=js"
export * from "./NeedsApprovalDetail.vue?vue&type=script&lang=js"
import style0 from "./NeedsApprovalDetail.vue?vue&type=style&index=0&id=61fa470a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fa470a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61fa470a')) {
      api.createRecord('61fa470a', component.options)
    } else {
      api.reload('61fa470a', component.options)
    }
    module.hot.accept("./NeedsApprovalDetail.vue?vue&type=template&id=61fa470a&scoped=true", function () {
      api.rerender('61fa470a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/online-transaction/components/Modal/NeedsApprovalDetail.vue"
export default component.exports